import React from 'react';

import { NuqsAdapter } from 'nuqs/adapters/react-router/v8';

import { AuthCredentialsProvider } from '@hrlogics/react-auth';

import { DatePickerLocalizationProvider } from 'src/components/finalForm';
import {
  AWS_COGNITO_CLIENT_ID,
  AWS_COGNITO_ENDPOINT,
  AWS_COGNITO_REGION,
  STRIPE_PUBLIC_KEY,
} from 'src/config';
import { ModalsV2Root } from 'src/modals/root/ModalsV2Root';
import { ApolloProvider } from 'src/providers/ApolloProvider';
import { AuthProvider } from 'src/providers/AuthProvider';
import { CognitoProvider } from 'src/providers/CognitoProvider';
import { DemoPrivacyModeProvider } from 'src/providers/DemoPrivacyModeProvider';
import { ModalsProvider } from 'src/providers/ModalsProvider';
import { ModalsV2Provider } from 'src/providers/ModalsV2Provider';

import { AppRouter } from './AppRouter';
import { StripeInstanceProvider } from './providers/StripeInstanceProvider';

export const App: React.FC = () => {
  return (
    <DatePickerLocalizationProvider>
      <CognitoProvider
        region={AWS_COGNITO_REGION}
        clientId={AWS_COGNITO_CLIENT_ID}
        endpoint={AWS_COGNITO_ENDPOINT}
      >
        <AuthCredentialsProvider>
          <ApolloProvider>
            <DemoPrivacyModeProvider>
              <AuthProvider>
                <ModalsV2Provider>
                  <ModalsProvider>
                    <StripeInstanceProvider publicKey={STRIPE_PUBLIC_KEY}>
                      <NuqsAdapter>
                        <AppRouter />
                      </NuqsAdapter>
                    </StripeInstanceProvider>
                  </ModalsProvider>
                  <ModalsV2Root />
                </ModalsV2Provider>
              </AuthProvider>
            </DemoPrivacyModeProvider>
          </ApolloProvider>
        </AuthCredentialsProvider>
      </CognitoProvider>
    </DatePickerLocalizationProvider>
  );
};
